import { useState } from "react";
import { clubApi } from "../api/club.service";
import { ClubPayload } from "../types";

export const useCreate = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const mutation = async (payload: ClubPayload) => {
    try {
      setLoading(true);

      const response: any = await clubApi.create(payload);

      return {
        success: true,
        message: response?.data?.message,
      };
    } catch (err: any) {
      console.error("Create club failed:", err);

      return {
        success: false,
        message: err?.response?.data?.error?.message_vi || "Something wrong",
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    mutation,
    loading,
  };
};
